export default function decodeHTMLString(string: string): string {
  const textarea = document.createElement('textarea')
  textarea.innerHTML = string
  return textarea.value
}
